"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceName = void 0;
/**
 * List of device names
 *
 * @public
 * @constant
 */
var DeviceName;
(function (DeviceName) {
    DeviceName["Desktop"] = "Desktop";
    DeviceName["Mobile"] = "Mobile";
    DeviceName["Tablet"] = "Tablet";
})(DeviceName = exports.DeviceName || (exports.DeviceName = {}));
//# sourceMappingURL=device-names.js.map